<template>
	<header>
		<!-- start topbar -->
		<div class="topbar">
			<div class="container">
				<div class="row">
					<header-support v-once />
					<!-- <header-language /> -->
				</div>
			</div>
		</div>
		<!-- end topbar -->

		<!-- start menubar -->
		<div id="menubar" class="menubar" :class="{ sticky: sticky }">
			<div class="container">
				<div class="row">
					<div class="col-lg-3 col-md-12 col-sm-12 col-xs-12">
						<header-logo v-once />
						<header-menu-icon v-once />
					</div>
					<div class="col-lg-9 col-md-12 col-sm-12 col-xs-12 text-right hidden-md hidden-sm hidden-xs">
						<nav class="menu-wrap">
							<header-navigation />
						</nav>
					</div>
				</div>
			</div>
		</div>
		<!-- end menubar -->

		<!-- start mobile menubar -->
		<div class="menubar-mobile">
			<div class="menubar-mobile-logo-wrap">
				<header-logo v-once />
				<header-menu-icon v-once is-mobile />
			</div>
			<div class="menubar-mobile-menu-wrap">
				<header-navigation is-mobile />
			</div>
			<!-- <div v-if="isLoggedIn" class="menubar-mobile-bottom-wrap">
				<div class="menubar-mobile-bottom-wrap-inner clearfix">
					<div class="mobile-user-data pull-left">
						<router-link :to="{ name: 'logout' }" class="mobile-logout">{{ $t('Menu.Logout') }}</router-link>
					</div>
				</div>
			</div> -->
		</div>
		<!-- end mobile menubar -->
	</header>
</template>

<script>
import AccountInfo from '@/mixins/AccountInfo'
// import HeaderLanguage from '@/components/header/HeaderLanguage.vue'
import HeaderLogo from '@/components/header/HeaderLogo'
import HeaderMenuIcon from '@/components/header/HeaderMenuIcon'
import HeaderNavigation from '@/components/header/HeaderNavigation'
import HeaderSupport from '@/components/header/HeaderSupport'

export default {
	name: 'HeaderContainer',
	components: {
		// HeaderLanguage,
		HeaderLogo,
		HeaderMenuIcon,
		HeaderNavigation,
		HeaderSupport,
	},
	mixins: [AccountInfo],
	data() {
		return {
			sticky: false,
		}
	},
	mounted() {
		window.document.onscroll = () => {
			const navBar = document.getElementById('menubar')
			if (window.scrollY > navBar.offsetTop) {
				this.sticky = true
			} else {
				this.sticky = false
			}
		}
	},
}
</script>



// WEBPACK FOOTER //
// src/components/header/HeaderContainer.vue